import { render } from "./TapirWidget.vue?vue&type=template&id=41fdd027"
import script from "./TapirWidget.vue?vue&type=script&lang=js"
export * from "./TapirWidget.vue?vue&type=script&lang=js"

import exportComponent from "/Users/td/Pro/projects/vue-audio-tapir/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__